import { render, staticRenderFns } from "./BookingPrivacyPopup.vue?vue&type=template&id=287d8e8c&scoped=true"
import script from "./BookingPrivacyPopup.vue?vue&type=script&lang=js"
export * from "./BookingPrivacyPopup.vue?vue&type=script&lang=js"
import style0 from "./BookingPrivacyPopup.vue?vue&type=style&index=0&id=287d8e8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d8e8c",
  null
  
)

export default component.exports